define([
	"dojo/_base/declare",
	"underscore",
	"csi/_base/storage",
	"csi/core/Key",
	"csi/table/Widget",
	"csi/xml"
], function(declare, _, storage, Key, Table, xml) {

	return declare(Table, {
		STORAGE_KEY: "ProductSalesRegionURL",
		STORAGE_KEY_TDS: "TDSProductSalesRegionURL",

		/**
		 * @override
		 * Hide special headings is sales region not selected
		 */
		onViewResolveKeysToSkip(skipSet) {
			if (!xml.isValidURL(this.activeProductSalesRegion)) {
				skipSet.add(Key.untypedKeyFromParts({
					name: "CareIconsMatrix",
				}));
				skipSet.add(Key.untypedKeyFromParts({
					name: "ProductSalesRegionSpec",
				}));
			}
		},

		onViewCreate: function() {
			var key = this._isUnderTDSView() ? this.STORAGE_KEY_TDS : this.STORAGE_KEY;

			this.set("activeProductSalesRegion", storage.get(key));

			this.watch("activeProductSalesRegion", function(name, oldValue, newValue) {
				storage.set(key, newValue);
			});

			this.inherited(arguments);
		},

		getPrintProperties: function() {
			// summary: return object containing properties from view necessary to recreate it for printing that are not custom view options
			var params = this.inherited(arguments);
			params.activeProductSalesRegion = this.activeProductSalesRegion;
			return params;
		},

		_isUnderTDSView: function() {
			// Return boolean if the view sub-view under the TDS composite view
			var parentView = this.viewParent;
			return parentView && parentView.defView.m_id == "TDS";
		}

	});
});